<template>
    <div class="container mx-auto px-8">
        <FormKit type="form" @submit="submit" v-model="data">
            <FormKitSchema :schema="JSON.parse(schemaAffiliate.signup_formkit_schema)" />
        </FormKit>
        <p v-if="submitted">Thank you for submitting!</p>
    </div>
</template>

<script setup>
import { FormKit } from "@formkit/vue";
import { usePage, router } from "@inertiajs/vue3";
import { computed, ref } from "vue";

const page = usePage();
const affiliate = computed(() => page.props.affiliate);
const schemaAffiliate = computed(() => page.props.schemaAffiliate);
const data = ref({});

const submitted = ref(false);

const submit = () => {
    router.post(`/sign-up/${affiliate.value.short_uuid}`, data.value, {
        headers: {
            "X-CSRF-Token": page.props.csrfToken,
        },
        onSuccess: () => {
            submitted.value = true;
        },
    });
};
</script>
